<div class="export-dialog">
  @if (setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }

  <h2 mat-dialog-title class="export-title">
    <mat-icon>download</mat-icon>
    <span class="export-title-text">Export Advisor Data</span>

    <!-- Actions live in the header, so they stay put while the content scrolls. -->
    <span class="title-actions">
      <button mat-stroked-button type="button" [disabled]="setSprinner()" (click)="cancel()">Cancel</button>
      <button type="button" class="export-confirm-btn" [disabled]="!canExport()"
        [matTooltip]="canExport() ? '' : 'Select at least one field to export'"
        (click)="confirm()">
        <mat-icon>download</mat-icon>
        Export Excel
      </button>
    </span>
  </h2>

  <mat-dialog-content>

    <!-- ① Rep status ─────────────────────────────────────────── -->
    <section class="export-step">
      <header class="step-header">
        <span class="step-index">1</span>
        <span class="step-label">Rep Status</span>
      </header>

      <div class="status-chips" role="radiogroup" aria-label="Rep status filter">
        @for (option of statusOptions; track option.value) {
        <button type="button" class="status-chip" [class.active]="selectedStatus() === option.value"
          role="radio" [attr.aria-checked]="selectedStatus() === option.value"
          (click)="selectStatus(option.value)">
          <mat-icon class="chip-check">check</mat-icon>
          {{ option.label }}
        </button>
        }
      </div>
    </section>

    <!-- ② Fields by section ──────────────────────────────────── -->
    <section class="export-step">
      <header class="step-header">
        <span class="step-index">2</span>
        <span class="step-label">Fields by section</span>
        <button type="button" class="link-btn" (click)="saveSelection()">Save Fields Selection</button>
        <button type="button" class="link-btn" (click)="clearSelection()">Clear all</button>
      </header>

      <div class="field-search">
        <mat-icon>search</mat-icon>
        <input type="text" [value]="fieldSearch()" (input)="onSearchChange($any($event.target).value)"
          placeholder="Search fields across all sections" aria-label="Search fields" />
        @if (fieldSearch()) {
        <button type="button" class="search-clear" (click)="onSearchChange('')" aria-label="Clear field search">
          <mat-icon>close</mat-icon>
        </button>
        }
      </div>

      <!-- Single expansion: opening a section collapses the one before it. -->
      <mat-accordion class="section-accordion">
        @for (row of sectionRows(); track row.section.id) {
        <mat-expansion-panel class="section-panel" hideToggle [expanded]="isOpen(row.section.id)"
          (opened)="setOpen(row.section.id, true)" (closed)="setOpen(row.section.id, false)">
          <mat-expansion-panel-header collapsedHeight="46px" expandedHeight="46px">
            <mat-panel-title class="section-panel-title">
              <mat-icon class="section-chevron">chevron_right</mat-icon>
              <mat-icon class="section-panel-icon">{{ row.section.icon }}</mat-icon>
              <span class="section-panel-name">{{ row.section.title }}</span>
              <span class="section-count" [class.empty]="!row.selectedCount">
                {{ row.selectedCount }} / {{ row.section.fields.length }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-actions">
            <button type="button" class="link-btn" (click)="selectAllIn(row)">Select all</button>
            <button type="button" class="link-btn" (click)="clearIn(row)">Clear</button>
          </div>

          <div class="field-grid">
            @for (field of row.rows; track field.id) {
            <!-- mat-checkbox renders its own <label>, so this row must not be one. -->
            <div class="field-row">
              <mat-checkbox [checked]="isSelected(field.id)"
                (change)="toggleField(field.id, $event.checked)">
                {{ field.field.label }}
              </mat-checkbox>
            </div>
            }
          </div>
        </mat-expansion-panel>
        } @empty {
        <p class="field-empty">
          <mat-icon>search_off</mat-icon>
          No fields match “{{ fieldSearch() }}”.
        </p>
        }
      </mat-accordion>
    </section>

    <!-- Selection summary ────────────────────────────────────── -->
    <section class="summary-panel">
      <header class="summary-header">
        <mat-icon class="step-icon">view_column</mat-icon>
        <span class="step-label">
          {{ selectedFields().length }} column{{ selectedFields().length === 1 ? '' : 's' }} selected
        </span>
        <!-- Only meaningful once a previous export has seeded the picker. -->
        @if (hasSeed()) {
        <button type="button" class="link-btn" (click)="resetToSeed()">Reset to last export</button>
        }
      </header>

      @if (selectedFields().length) {
      <div class="summary-groups">
        @for (group of selectionBySection(); track group.title) {
        <div class="summary-group">
          <span class="summary-group-title">{{ group.title }}</span>
          <div class="summary-chips">
            @for (entry of group.fields; track entry.id) {
            <span class="summary-chip">
              {{ entry.field.label }}
              <button type="button" (click)="removeSelected(entry.id)"
                [attr.aria-label]="'Remove ' + entry.field.label">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <p class="summary-empty">
        <mat-icon>error_outline</mat-icon>
        Select at least one field to export.
      </p>
      }
    </section>

  </mat-dialog-content>
</div>
